import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { useCallSessionRoomStore } from '@/entities/call-session'
import { STATE, useWebRTC } from '@/entities/webrtc'

import { resolveChatMessagingUiEnabled } from '@/shared/composables/user-features'
import { pathNames } from '@/shared/utils/constants'
import { getChatRoute } from '@/shared/utils/url'

const isAnsweredSessionState = (state: STATE) => state === STATE.CONNECTED || state === STATE.ONHOLD

const mainRoute = { name: pathNames.MAIN }

export const callSessionBeforeEnter = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): void => {
  const { sessionId } = to.params

  if (!sessionId) {
    next(mainRoute)
  } else if (typeof sessionId === 'string') {
    const { getRTCSessionFacadeById } = useWebRTC()
    const facade = getRTCSessionFacadeById(sessionId)

    if (!facade) {
      next(mainRoute)
      return
    }

    if (!isAnsweredSessionState(facade.sessionState.value)) {
      const room = useCallSessionRoomStore().getRoom(sessionId)
      const chatRoute = room ? getChatRoute(room) : null
      if (chatRoute && resolveChatMessagingUiEnabled()) {
        next(chatRoute)
        return
      }

      next(mainRoute)
      return
    }

    next()
  }
}
